import { PlanSection } from './plan-section-phase2'

export default PlanSection
